<div class="staff-select-dialog">
  <!-- Search bar -->
  <div class="search-bar">
    <div class="search-input-wrapper">
      <input class="search-input"
             type="text"
             [formControl]="searchControl"
             placeholder="Search staff"
             autocomplete="off"
             cdkFocusInitial>
      <div class="search-underline"></div>
    </div>
    <button mat-flat-button
            color="primary"
            class="select-btn"
            [disabled]="!selectedStaff"
            (click)="onSelect()">
      Select
    </button>
    <button mat-icon-button
            class="close-btn"
            (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Role filter chips -->
  <div class="role-filter-bar" *ngIf="allRoles.length > 0">
    <span class="role-filter-label">Roles</span>
    <div class="role-chips">
      <button *ngFor="let role of allRoles"
              class="role-chip"
              [class.active]="isRoleActive(role)"
              [class.locked]="rolesLocked"
              (click)="toggleRole(role)">
        {{ getRoleName(role) }}
        <mat-icon class="role-lock-icon" *ngIf="rolesLocked && isRoleActive(role)">lock</mat-icon>
      </button>
    </div>
  </div>

  <!-- Staff grid -->
  <mat-dialog-content class="staff-grid-container">
    <div class="staff-grid">
      <button *ngFor="let staff of filteredStaff"
              class="staff-tile"
              [class.selected]="isSelected(staff)"
              (click)="onStaffClick(staff)">
        <span class="staff-firstname">{{ staff.FirstName }}</span>
        <span class="staff-lastname">{{ staff.LastName }}</span>
        <span class="staff-roles" *ngIf="getRoles(staff)">{{ getRoles(staff) }}</span>
      </button>
    </div>
    <p class="no-results" *ngIf="filteredStaff.length === 0">No staff match your filters</p>
  </mat-dialog-content>
</div>
